<template>
    <div v-if="showMain == true">
        <v-layout wrap>
            <v-flex xs12 sm6 md6 lg6 xl6>
                <div>
                    <div class="tableHeader">Danh sách học viên đã nộp bài</div>
                    <v-data-table :headers="answeredHeaders" :items="completedStudent" class="elevation-1"
                                  hide-actions>
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-center">{{ props.index+1 }}</td>
                            <td class="text-xs-left">{{ props.item.userName }}</td>
                            <td class="text-xs-right">{{ props.item.mark }}</td>
                            <td class="text-xs-left">{{ getStatusText(props.item.status) }}</td>
                            <td class="text-xs-left">{{ props.item.endTime | formatDateTime }}</td>
                            <td class="justify-center layout px-0">
                                <v-btn @click="viewStudentAnswer(props.item.userId)" class="mx-0" icon>
                                    <v-icon color="primary">visibility</v-icon>
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>
                </div>
                <div>
                    <div class="tableHeader" style="background-color: orange">Danh sách học viên chưa nộp bài
                    </div>
                    <v-data-table :headers="unAnsweredHeaders" class="elevation-1"
                                  :items="notCompletedStudent" hide-actions>
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-center">{{ props.index+1 }}</td>
                            <td class="text-xs-left">{{ props.item.fullName }}</td>
                            <!--td class="text-xs-left">{{ props.item.endTime | formatDateTime }}</td-->
                            <td class="text-xs-left">
                                <v-btn @click="toReportView" class="mx-0" color="primary">
                                    <!--v-icon color="primary">visibility</v-icon-->
                                    Nhập điểm
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>
                    <div></div>
                </div>
            </v-flex>
            <v-flex xs12 sm6 md6 lg6 xl6>
                <canvas id="student-chart"
                        style="border:1px solid rgba(0,0,0,0.12);margin-top:10px;margin-left: 10px"/>

                <canvas id="mark-report-chart"
                        style="border:1px solid rgba(0,0,0,0.12);margin-top:10px;margin-left: 10px"/>

                <div style="border:1px solid rgba(0,0,0,0.12);margin-top:10px;margin-left: 10px;width: 100%">
                    <table style="width: 100%">
                        <tr>
                            <th width="50%" style="vertical-align: top;padding:5px;text-align: left;">
                                <v-icon color="orange">sentiment_satisfied_alt</v-icon>
                                Top 3 học viên làm tốt
                            </th>
                            <th width="50%" style="vertical-align: top;padding:5px;text-align: left">
                                <v-icon color="blue">sentiment_very_dissatisfied</v-icon>
                                Top 3 học viên làm bài chưa tốt
                            </th>
                        </tr>
                        <tr>
                            <td style="vertical-align: top;padding:5px">
                                <table width="80%">
                                    <tr v-for="item in lstTop">
                                        <td>
                                            <v-icon color="orange">sentiment_satisfied_alt</v-icon>
                                            {{item.userName}}
                                        </td>
                                        <td>{{item.mark}}</td>
                                    </tr>
                                </table>
                            </td>
                            <td style="vertical-align: top;padding:5px">
                                <table width="80%">
                                    <tr v-for="item in lstBottom">
                                        <td>
                                            <v-icon color="blue">sentiment_very_dissatisfied</v-icon>
                                            {{item.userName}}
                                        </td>
                                        <td>{{item.mark}}</td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>
                </div>
            </v-flex>
        </v-layout>
    </div>
    <div v-else>
        <do-quiz :question="exercise" :student-id="studentId" view="teacher" v-if="exerciseType==6" @onback="back"/>
        <do-essay :question="exercise" :student-id="studentId" view="teacher" v-else @onback="back"/>
    </div>

</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import DoQuiz from "../doQuiz";
    import DoEssay from "../doEssay";

    export default {
        name: "answer-of-student",
        components: {DoEssay, DoQuiz},
        props: {
            classId: {
                type: String | Number,
                default: null
            },

            exerciseId: {
                type: String | Number,
                default: null
            },

            exercise: {
                type: Object,
                default: null
            },

            exerciseType: {
                type: String | Number,
                default: null
            },
        },

        data: () => ({
            studentId: null,
            showMain: true,
            averageMark: null,
            answeredHeaders: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    value: "userName"
                },
                {
                    text: "Họ và tên",
                    align: "left",
                    sortable: false,
                    value: "userName"
                },
                {
                    text: "Điểm",
                    align: "right",
                    sortable: false,
                    value: "mark"
                },
                {
                    text: "Trạng thái",
                    align: "left",
                    sortable: false,
                    value: "status"
                },
                {
                    text: "Hoàn thành",
                    align: "left",
                    sortable: false,
                    value: "endTime"
                },
                {text: "Actions", value: "name", align: "center", sortable: false}
            ],
            unAnsweredHeaders: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    value: "fullName"
                },
                {
                    text: "Họ và tên",
                    align: "left",
                    sortable: false,
                    value: "fullName"
                },
                {
                    text: "Nhập điểm",
                    align: "left",
                    sortable: false,
                    value: "status"
                },
            ],
            teachers: [],
            completedStudent: [],
            notCompletedStudent: [],
            lstTop: [],
            lstBottom: [],
        }),

        computed: {},

        watch: {
            dialog(val) {
                val || this.close();
            }
        },

        created() {
            this.init();
        },

        methods: {
            init: function () {
                this.getCompletedStudent();
                this.getUnCompletedStudent();
                this.getStudentCountByStatus();
                this.getMarkReport();
            },

            calculateTopStudent() {
                this.completedStudent.sort((a, b) => {
                    return b.mark - a.mark;
                });
                this.lstTop = [];
                this.lstBottom = [];
                //console.log(this.completedStudent);
                for (let i = 0; i < this.completedStudent.length && i < 3; i++) {
                    if (this.completedStudent[i].mark >= 7) {
                        this.lstTop.push(this.completedStudent[i]);
                    }
                }
                let start = this.completedStudent.length - 3;
                if (start < 0) {
                    start = 0;
                }
                console.log(this.completedStudent);
                for (let i = this.completedStudent.length-1; i>=0;i--) {
                    if (this.completedStudent[i].mark != null && this.completedStudent[i].mark <= 5 ) {
                        this.lstBottom.push(this.completedStudent[i]);
                        if(this.lstBottom.length==3){
                            break;
                        }
                    }
                }
                //console.log(this.lstTop);
                //console.log(this.lstBottom);

            },

            getCompletedStudent: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/answeredList?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            this.completedStudent = data.items;
                            this.calculateTopStudent();
                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            getUnCompletedStudent: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/unAnsweredList?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            this.notCompletedStudent = data.items;
                            this.calculateTopStudent();
                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            getStudentCountByStatus: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/countStudentByStatus?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            this.mapStatus = data;
                            const ctx = document.getElementById('student-chart');
                            const chart = new Chart(ctx, {
                                type: 'pie',
                                data: {
                                    labels: ["Chưa nộp", "Đã nộp", "Đã chấm", "Đã trả bài"],
                                    datasets: [
                                        {
                                            data: [this.mapStatus[0], this.mapStatus[2], this.mapStatus[3], this.mapStatus[4]],
                                            backgroundColor: [
                                                'orange', // Blue
                                                '#ffcd56',
                                                '#36a2eb',
                                                '#ff6384'
                                            ],
                                        }
                                    ]
                                },
                                options: {
                                    title: {
                                        display: true,
                                        text: 'Biểu đồ thống kê trạng thái nộp bài cùa học sinh'
                                    }
                                },
                            });

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            getMarkReport: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/getMarkReportOfExercise?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            this.mapMark = data;
                            this.averageMark = data[0];
                            const ctxmark = document.getElementById('mark-report-chart');
                            const chartmark = new Chart(ctxmark, {
                                type: 'doughnut',
                                data: {
                                    labels: ["<6.5", "6.5-8", "≥8"],
                                    datasets: [
                                        {
                                            data: [this.mapMark[6], this.mapMark[8], this.mapMark[10]],
                                            backgroundColor: [
                                                '#36a2eb',
                                                'orange', // Blue
                                                '#ffcd56',
                                                '#ff6384'
                                            ],
                                        }
                                    ]
                                },
                                options: {
                                    title: {
                                        display: true,
                                        text: 'Biểu đồ thống kê điểm cùa học sinh'
                                    }
                                },
                            });

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            viewStudentAnswer: function (userId) {
                this.studentId = userId;
                this.showMain = false;
                this.$emit("showBackBtn", false);

            },

            getStatusText: function (status) {
                switch (status) {
                    case 0:
                    case 1:
                        return this.$t('lang.exercise.doing');
                        break;
                    case 2:
                        return this.$t('lang.exercise.sent');
                        break;
                    case 3:
                        return this.$t('lang.exercise.marked');
                        break;
                    case 4:
                        return this.$t('lang.exercise.returned');
                        break;
                    default:
                        return "";
                }
            },

            toReportView() {
                this.$emit("toReport");
            },

            back: function () {
                this.showMain = true;
                this.$emit("showBackBtn", true);
            }
        }
    };
</script>